/* eslint-disable */
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { ApplicationProxyService } from '../shared/services/applicationproxy.service';
import { ApplicationActions } from '../actions/application.actions';
import { FlowManagerService } from '../shared/services/flowmanager.service';
import { LoggerService } from '../shared/services/logger.service';
import { CookieService } from 'angular2-cookie/core';

@Injectable()
export class DataResolver implements Resolve {
  constructor(
    appProxy: ApplicationProxyService,
    appActions: ApplicationActions,
    flowManager: FlowManagerService,
    logService: LoggerService,
    cookieService: CookieService) {
    this.appProxy = appProxy;
    this.appActions = appActions;
    this.flowManager = flowManager;
    this.logService = logService;
    this.cookieService = cookieService;
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    return new Promise(resolve => {
      const validationSchema = this.flowManager.getValidationSchema();

      const appType = this.flowManager.getAppType();
      const experiments = this.flowManager.experiments;
      const isAuth = this.flowManager.isAuthed;

      let url = route.url;
      if (route.url[0] === undefined) url = 'get-started';
      console.time('formLoad');
      this.appProxy.getFormJSON(appType, url, { experiments, isAuth }, v => {
        console.timeEnd('formLoad');

        // @TODO Clean this up to where all the experiments come back in one prop.
        this.flowManager.experiments = v.experiments;
        this.flowManager.experiments = v.pageValuePropExperiments;
        this.flowManager.dtmExperiments = v.pageExperiments;

        this.logService.logPageLoad(route);
        this.flowManager.updateValueProp = v.form.extraPageInfo.valueProp[appType];
        this.flowManager.updateFAQ = v.form.extraPageInfo.faq[appType];
        this.flowManager.setWhyWeAsk(v.form.whyWeAsk);
        this.appActions.setData('stepUserIsOn', v.form.stepNum);

        // Progress Bar logic
        const formStep = v.form.stepNum ? v.form.stepNum - 1 : 0;
        const userOnStep = this.appActions.getData('progressBar.userOnStep', 0);
        const hasCompletedStep = this.appActions.getData('progressBar.hasCompletedStep', 0);
        if (formStep > userOnStep && hasCompletedStep < userOnStep) {
          this.appActions.setData('progressBar.hasCompletedStep', userOnStep);
        }
        this.appActions.setData('progressBar.userOnStep', formStep);

        v.cookiesToRemove.forEach(cookie => {
          this.cookieService.remove(cookie);
        });

        // Show/hide fields on deposit routes
        if (this.flowManager.isOneAllyBank === true) {
          const depositURLs = [
            'deposit-funds',
            'deposit-funds-ira',
            'review-deposit-funds',
            'review-deposit-funds-ira',
            'deposit-funds-receipt'
          ];
          const currentRoute = url[0].path;

          if (this.flowManager.isRecurringDeposit && depositURLs.includes(currentRoute)) {
            let startLabel = 'Deliver first transfer on';

            if (currentRoute === 'review-deposit-funds' || currentRoute === 'review-deposit-funds-ira') {
              startLabel = `${startLabel}:`;
            } else if (currentRoute === 'deposit-funds-receipt') {
              startLabel = `<span><strong>${startLabel}:</strong></span>`;
            }

            v.form.inputs.depositDate.label = startLabel;
          }
        }
        // Had to move this to the end, you can't resolve the promise in a resolver until
        // all the data is back or else data can get out of sync and cause errors
        if (Object.keys(validationSchema).length === 0) {
          this.appProxy.getValidationSchema(res => {
            this.flowManager.setValidationSchema(res);
            resolve(v.form);
          });
        } else {
          resolve(v.form);
        }
      });
    });
  }
}
